
export default {

    // add incident-management flags here
    // A flag should specify its status on all the environments
    // Example:
    ticketSubmit: {
        Production: false,
        PreProduction: false,
        QA: false,
        SVT: false,
        UAT: true,
        Mock: true,
        Development: true,
        Local: true
    },
    resolutionConfirmation: {
        Production: false,
        PreProduction: false,
        QA: false,
        SVT: false,
        UAT: false,
        Mock: true,
        Development: true,
        Local: true
    },
    liveChat: {
        Production: true,
        PreProduction: true,
        QA: true,
        SVT: true,
        UAT: true,
        Mock: true,
        Development: true,
        Local: true
    },
    chartsDashboard: {
        Production: true,
        PreProduction: true,
        QA: true,
        SVT: true,
        UAT: true,
        Mock: true,
        Development: true,
        Local: true
    },
    customerReference: {
        Production: true,
        PreProduction: true,
        QA: true,
        SVT: true,
        UAT: true,
        Mock: true,
        Development: true,
        Local: true
    },
    customerReferenceErrorScenario: {
        Production: true,
        PreProduction: true,
        QA: true,
        SVT: true,
        UAT: true,
        Mock: true,
        Development: true,
        Local: true
    },
    staffAccessChatIcon: {
        Production: false,
        PreProduction: false,
        QA: false,
        SVT: false,
        UAT: false,
        Mock: false,
        Development: false,
        Local: false
    },
    buttonIntegrations: {
        Production: true,
        PreProduction: true,
        UAT: true,
        SVT: true,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    }
};
